import { OnInit, EventEmitter } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { HttpResponse } from '@angular/common/http';
import { ClientService } from 'app/services/client-service';
import { ToastrService } from 'ngx-toastr';
import { CommonsText } from 'app/commons/CommonsText';
import { PolicyService } from 'app/services/policy-service';
var ProfileBankEditionComponent = /** @class */ (function () {
    function ProfileBankEditionComponent(formBuilder, clientService, toastr, policyService) {
        this.formBuilder = formBuilder;
        this.clientService = clientService;
        this.toastr = toastr;
        this.policyService = policyService;
        this.profileAction = new EventEmitter();
        this.messages = null;
        this.running = false;
        this.loading = false;
        this.accountList = [];
        this.policyList = [];
        this.showBankForm = false;
        this.bankDocumentName = null;
        this.bankDocumentFile = null;
        this.isDragOver = false;
        this.changingAccountId = null;
        this.MAX_FILE_SIZE = 10485760;
    }
    ProfileBankEditionComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.bankForm = this.formBuilder.group({
            bankIban: ['', [Validators.required, Validators.minLength(4)]],
            bankEntity: ['', [Validators.required, Validators.minLength(4)]],
            bankBranch: ['', [Validators.required, Validators.minLength(4)]],
            bankDc: ['', [Validators.required, Validators.minLength(2)]],
            bankAccount: ['', [Validators.required, Validators.minLength(10)]],
            bankHolder: ['', [Validators.required]],
            bankHolderType: ['', [Validators.required]],
            bankHolderNumber: ['', [Validators.required]]
        });
        this.bankForm.valueChanges.subscribe(function () {
            if (_this.bankForm.touched || _this.bankForm.dirty) {
                _this.messages = _this.bankForm.invalid ? [CommonsText.TODOS_CAMPOS_OBLIGATORIOS] : null;
            }
        });
        this.loadData();
    };
    ProfileBankEditionComponent.prototype.loadData = function () {
        var _this = this;
        this.loading = true;
        Promise.all([
            this.clientService.getClient(),
            this.clientService.getPaymentAccounts(),
            this.policyService.getCurrent()
        ]).then(function (_a) {
            var client = _a[0], accountList = _a[1], policyList = _a[2];
            _this.loading = false;
            _this.client = client;
            _this.accountList = accountList.response;
            _this.patchHolderData();
            if (policyList.response !== null && policyList.response !== undefined) {
                policyList.response.forEach(function (policy) {
                    if ((policy.collective === null || policy.collective === undefined) && policy.isTaker) {
                        _this.policyList.push(policy);
                    }
                    else if (policy.collective > 0 && policy.isTaker) {
                        _this.policyList.push(policy);
                    }
                });
            }
        }).catch(function () {
            _this.loading = false;
            _this.toastr.error(CommonsText.PROBLEMA_SERVICIO_TIPOS_CUENTAS, CommonsText.PROBLEMA_DE_CONECTIVIDAD, {
                timeOut: 5000
            });
        });
    };
    ProfileBankEditionComponent.prototype.patchHolderData = function () {
        if (!this.client) {
            return;
        }
        var name = '';
        if (this.client.name) {
            name += this.client.name;
        }
        if (this.client.surname) {
            name += ' ' + this.client.surname;
        }
        if (this.client.lastName) {
            name += ' ' + this.client.lastName;
        }
        this.bankForm.patchValue({
            bankHolder: name.trim(),
            bankHolderType: this.client.documentType || '',
            bankHolderNumber: this.client.documentNumber || ''
        });
    };
    ProfileBankEditionComponent.prototype.toggleBankForm = function () {
        this.showBankForm = !this.showBankForm;
    };
    ProfileBankEditionComponent.prototype.onBankDocumentSelected = function (event) {
        var file = event.target.files && event.target.files[0];
        if (file) {
            this.setBankDocument(file);
        }
        event.target.value = '';
    };
    ProfileBankEditionComponent.prototype.onRemoveBankDocument = function () {
        this.bankDocumentFile = null;
        this.bankDocumentName = null;
    };
    ProfileBankEditionComponent.prototype.onDragOver = function (event) {
        event.preventDefault();
        event.stopPropagation();
        this.isDragOver = true;
    };
    ProfileBankEditionComponent.prototype.onDragLeave = function (event) {
        event.preventDefault();
        event.stopPropagation();
        this.isDragOver = false;
    };
    ProfileBankEditionComponent.prototype.onDrop = function (event) {
        event.preventDefault();
        event.stopPropagation();
        this.isDragOver = false;
        var file = event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files[0];
        if (file) {
            this.setBankDocument(file);
        }
    };
    ProfileBankEditionComponent.prototype.setBankDocument = function (file) {
        if (file.size > this.MAX_FILE_SIZE || !this.isValidFileType(file.type)) {
            this.toastr.error(CommonsText.ARCHIVO_ADJUNTO_TAMAÑO_MAXIMO_FORMATO_PERMITIDO, CommonsText.ERROR_ADJUNTANDO_ARCHIVO);
            return;
        }
        this.bankDocumentFile = file;
        this.bankDocumentName = file.name;
    };
    ProfileBankEditionComponent.prototype.isValidFileType = function (type) {
        return !!type && (type.startsWith('image/') || type === CommonsText.PDF_TYPE);
    };
    ProfileBankEditionComponent.prototype.captureIban = function (event) {
        var pastedText = event.clipboardData.getData('text');
        if (pastedText !== undefined && pastedText !== null) {
            pastedText = pastedText.replace(/\s/g, '');
            if (pastedText.length === 24) {
                event.preventDefault();
                this.bankForm.patchValue({ bankIban: pastedText.substring(0, 4) });
                this.bankForm.patchValue({ bankEntity: pastedText.substring(4, 8) });
                this.bankForm.patchValue({ bankBranch: pastedText.substring(8, 12) });
                this.bankForm.patchValue({ bankDc: pastedText.substring(12, 14) });
                this.bankForm.patchValue({ bankAccount: pastedText.substring(14, 24) });
            }
        }
    };
    ProfileBankEditionComponent.prototype.submitEnabled = function () {
        return !this.running && this.bankForm.valid && !!this.bankDocumentFile;
    };
    ProfileBankEditionComponent.prototype.getButtonLabel = function () {
        return this.running ? CommonsText.CARGANDO : CommonsText.GUARDAR_CAMBIOS_MINUSCULA;
    };
    ProfileBankEditionComponent.prototype.onSave = function () {
        var _this = this;
        if (this.running) {
            return;
        }
        if (this.bankForm.invalid || !this.bankDocumentFile) {
            Object.keys(this.bankForm.controls).forEach(function (field) {
                _this.bankForm.get(field).markAsTouched({ onlySelf: true });
            });
            this.messages = [CommonsText.TODOS_CAMPOS_OBLIGATORIOS];
            return;
        }
        var account = {
            iban: this.bankForm.value.bankIban,
            entity: this.bankForm.value.bankEntity,
            office: this.bankForm.value.bankBranch,
            digit: this.bankForm.value.bankDc,
            accountNumber: this.bankForm.value.bankAccount,
            titular: this.bankForm.value.bankHolder,
            documentType: [{ id: this.bankForm.value.bankHolderType, itemName: this.bankForm.value.bankHolderType }],
            documentNumber: this.bankForm.value.bankHolderNumber
        };
        var uploadFormData = new FormData();
        uploadFormData.append('file', this.bankDocumentFile);
        this.running = true;
        this.messages = null;
        this.clientService.onAddNewAccount(account, uploadFormData)
            .subscribe(function (event) {
            if (event instanceof HttpResponse) {
                _this.running = false;
                _this.accountList = event.body.response;
                _this.showBankForm = false;
                _this.bankDocumentFile = null;
                _this.bankDocumentName = null;
                _this.bankForm.reset();
                _this.patchHolderData();
                _this.toastr.success(CommonsText.CUENTA_AYADIDA_EXITO, CommonsText.SERVICIO_DE_CUENTAS);
                _this.clientService.showModal();
            }
        }, function (error) {
            _this.running = false;
            _this.messages = (error.error && error.error.response) ? [error.error.response] : [CommonsText.PROBLEMA_DE_CONECTIVIDAD];
            _this.toastr.error(error.error.response, CommonsText.ERROR_SERVICIO_CUENTAS);
        });
    };
    ProfileBankEditionComponent.prototype.onCancel = function () {
        this.profileAction.emit({ section: 'bank' });
    };
    ProfileBankEditionComponent.prototype.onChangeAccount = function (event, policy) {
        var _this = this;
        this.clientService.showChangeReceipts();
        var accountNumber = event.target.value;
        if (accountNumber !== '' && policy.id !== '') {
            this.changingAccountId = policy.id;
            this.clientService.onChangeAccount(accountNumber, policy.id)
                .then(function () {
                _this.changingAccountId = null;
                policy.bankAccount = accountNumber;
                _this.toastr.success(CommonsText.CUENTA_CAMBIADA_EXITO, CommonsText.SERVICIO_DE_CUENTAS);
            }).catch(function () {
                _this.changingAccountId = null;
                _this.toastr.error(CommonsText.PROBLEMA_SERVICIO_TIPOS_CUENTAS, CommonsText.PROBLEMA_DE_CONECTIVIDAD, {
                    timeOut: 5000
                });
            });
        }
    };
    ProfileBankEditionComponent.prototype.onRemoveAccount = function (event, account) {
        var _this = this;
        var button = (event.target.parentNode.getElementsByTagName('button')[0]);
        var spinner = (event.target.parentNode.getElementsByTagName('i')[0]);
        button.style.display = 'none';
        spinner.style.display = 'initial';
        this.clientService.onRemoveAccount(account)
            .then(function (value) {
            _this.accountList = value.response;
            _this.toastr.success(CommonsText.CUENTA_REMOVIDA_EXITO, CommonsText.SERVICIO_DE_CUENTAS);
        }).catch(function (error) {
            button.style.display = 'initial';
            spinner.style.display = 'none';
            _this.toastr.error(CommonsText.PROBLEMA_SERVICIO_TIPOS_CUENTAS, CommonsText.PROBLEMA_DE_CONECTIVIDAD, {
                timeOut: 5000
            });
        });
    };
    return ProfileBankEditionComponent;
}());
export { ProfileBankEditionComponent };
